<script>
    import { info, credits } from '../store';
    import { numberFormatter, reset } from '../functions';
    import _ from 'lodash';

    import Step1 from './Step1.svelte';
    import Step3 from './Step3.svelte';
    import Step5 from './Step5.svelte';

    export let step;
    export let stepComponent;

    function first () {
        step = 1;
        stepComponent = Step1;
    }

    function prev () {
        step = 3;
        stepComponent = Step3;
    }

    function next () {
        step = 5;
        stepComponent = Step5;
    }

    function resetApp () {
        reset();
         $credits = [
            {
                name: '',
                loan_amount: '',
                duration: '',
                interest_rate: '',
                interest_rate_annually: 0,
                monthly_payment: 0,
                amount_paid: 0,
                interest_paid: 0,
            }
        ];
        $info = { name: '', income: 0, hours_month: 168, result_income_hour: 0, level_indebtedness: 0, amount_money_paid: 0, spending_hours_in_advance: 0, payment_option_credit: null };
        step = 1;
        stepComponent = Step1;
    }
</script>

<main>
    <div class="calculator-banometru-card active" id="card-4">
        <div class="text-center color-mov mb-4">
            <h2>Felicitări</h2>
        </div>

        <div class="container-700">
            <div class="subtitle text-center color-mov mb-4">Te-ai hotărât să îți achiți anticipat datoriile. Primul pas pe care îl ai de făcut este să îți promiți și să te ții de cele 2 angajamente de mai jos:</div>

            <div class="subtitle text-center color-mov mb-4"><strong>Angajament 1:</strong> Fac promisiunea că voi plăti în fiecare lună, până termin toate datoriile de plătit, minim <strong>{numberFormatter(_.sumBy($credits, 'monthly_payment'))}</strong> lunar</div>

            <div class="subtitle text-center color-mov mb-4"><strong>Angajament 2:</strong> Nu mai fac alte datorii pentru consum.</div>

            <div class="text-center color-orange mb-4">
                <h2>Ai de făcut o alegere.</h2>
            </div>

            <div class="row align-items-center justify-content-center">
                <div class="col-sm-auto mb-3 text-center">
                    <button class="buton bt-mov bt-next-step" on:click="{resetApp}">LAS, ALTĂ DATĂ</button>
                </div>
                <div class="col-sm-auto mb-3 text-center">
                    <button class="buton bt-mov bt-next-step" on:click="{next}">MĂ ANGAJEZ</button>
                </div>
            </div>

        </div>

        <div class="card-nav">
            <div class="bt-nav-calculator bt-prev bt-prev-step" on:click="{prev}">
                <div class="lab">Pasul anterior</div>
                <div class="icon"></div>
            </div>
        </div>
    </div>
</main>
